import { z } from "zod";

export const adGroupCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
});

export const adGroupUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  description: z.string().optional(),
});

export type AdGroupFormData = z.infer<typeof adGroupCreateSchema>;
export type AdGroupUpdateFormData = z.infer<typeof adGroupUpdateSchema>;

export interface AdGroup {
  id: string;
  name: string;
  description?: string;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AdGroupsResponse {
  adGroups: AdGroup[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface AdGroupFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface AdGroupRequest {
  name: string;
  description?: string;
}

export interface UpdateAdGroupPayload {
  id: string;
  adGroup: AdGroupUpdateFormData;
}
